import CompanyAccrediteeView from './CompanyAccreditee.view';

export default class CompanyAccrediteeUpdateView extends CompanyAccrediteeView {

    events() {
        return {
            'click .update': 'update',
            'click .back': 'backToOverview'
        };
    }

    initialize(options = {}) {
        super.initialize(options);
        this.isUpdating = true;
        this.syncingText = 'Updating Attendee...';
    }

    update() {
        if (this.model.isValid(true)) {
            this.model.save();
        }
    }

    onSync() {
        this.unbindModel();
        this.accreditees.bustCache();
        this.backToOverview();
    }

}
